// Which .vue renders each public route, per layout (#160243). Route names and
// paths live in src/router/customer.js and never change; only the component does.
import { LEGACY, NEW_ERA, currentTheme } from './index';

export const LOADERS = {
  [LEGACY]: {
    Shell: () =>
      import(/* webpackChunkName: "event" */ '@/views/customer/Events'),
    EventsCategories: () =>
      import(
        /* webpackChunkName: "events-list" */ '@/views/customer/EventsCategories'
      ),
    EventsList: () =>
      import(
        /* webpackChunkName: "events-list" */ '@/views/customer/EventsList'
      ),
    EventDetails: () =>
      import(
        /* webpackChunkName: "events-details" */ '@/views/customer/EventDetails'
      ),
    BookingThankYou: () =>
      import(
        /* webpackChunkName: "leave-thanks" */ '@/views/customer/BookingThankYou'
      ),
    TicketWaitZone: () => import('@/views/customer/TicketWaitZone'),
    NotFound: () =>
      import(/* webpackChunkName: "page-404" */ '@/views/customer/404'),
    // the payment page exists in new_era only
    Pay: () =>
      import(
        /* webpackChunkName: "new-era" */ '@/themes/new_era/views/RedirectToEvent.vue'
      ),
  },
  // Views are added here ticket by ticket; a missing name falls back to legacy.
  [NEW_ERA]: {
    Shell: () =>
      import(
        /* webpackChunkName: "new-era" */ '@/themes/new_era/EventsShell.vue'
      ),
    // One view serves both list routes; the category route preselects a chip.
    EventsCategories: () =>
      import(
        /* webpackChunkName: "new-era" */ '@/themes/new_era/views/EventsHome.vue'
      ),
    EventsList: () =>
      import(
        /* webpackChunkName: "new-era" */ '@/themes/new_era/views/EventsHome.vue'
      ),
    EventDetails: () =>
      import(
        /* webpackChunkName: "new-era" */ '@/themes/new_era/views/EventDetails.vue'
      ),
    Pay: () =>
      import(
        /* webpackChunkName: "new-era" */ '@/themes/new_era/views/SecurePayment.vue'
      ),
    // the steps after a free booking (#160557 R8, R9)
    TicketWaitZone: () =>
      import(
        /* webpackChunkName: "new-era" */ '@/themes/new_era/views/TicketWaitZone.vue'
      ),
    BookingThankYou: () =>
      import(
        /* webpackChunkName: "new-era" */ '@/themes/new_era/views/BookingThankYou.vue'
      ),
    NotFound: () =>
      import(
        /* webpackChunkName: "new-era" */ '@/themes/new_era/views/NotFound.vue'
      ),
  },
};

export function themeView(
  name,
  { theme = currentTheme, loaders = LOADERS } = {},
) {
  return async () => {
    const { layout } = await theme();
    const loader =
      (loaders[layout] && loaders[layout][name]) || loaders[LEGACY][name];
    const mod = await loader();
    return mod.default || mod;
  };
}
